import get from 'transmute/get';
import { EMAIL_METADATA } from '../constants/attachmentTypes';
import { getAttachments } from './getAttachments';
export const getEmailMetadata = commonMessage => {
  const attachments = getAttachments(commonMessage);
  if (attachments) {
    return attachments.find(attachmentObject => Boolean(attachmentObject && get('@type', attachmentObject) === EMAIL_METADATA));
  }
  return undefined;
};
export function getEmailMetadataPlainJS(commonMessage) {
  var _commonMessage$attach;
  return (_commonMessage$attach = commonMessage.attachments.find(isEmailMetadata)) !== null && _commonMessage$attach !== void 0 ? _commonMessage$attach : null;
}
export function isEmailMetadata(attachment) {
  return (attachment === null || attachment === void 0 ? void 0 : attachment['@type']) === 'EMAIL_METADATA';
}